/*
 *
 * RequestsPage14852
 *
 */

import React from 'react';

import RequestsPage from 'pages/Requests/RequestsPage';
import {TenantForm14852, TenantFormDialog14852} from './TenantView';
import {ReceptionDxGrid14852, ReceptionForm14852, ReceptionFormDialog14852} from './ReceptionView';
import {
    AdministratorForm14852,
    AdministratorFormDialog14852,
    AdministratorBCRequestsDxGrid14852
} from './AdministratorBCView';
import {AdminSkudDxGrid14852, AdminSkudForm14852} from "./AdminSkud";
import {getDetailContainer} from './common/detailContainers';


function RequestsPage14852(props) {
    return (
        <RequestsPage
            administratorBCDxGrid={<AdministratorBCRequestsDxGrid14852/>}
            administratorBCForm={<AdministratorForm14852/>}
            administratorBCFormDialog={
                <AdministratorFormDialog14852
                    form={<AdministratorForm14852/>}
                    detailContainer={getDetailContainer()}
                />
            }
            tenantForm={<TenantForm14852/>}
            tenantFormDialog={
                <TenantFormDialog14852
                    form={<TenantForm14852/>}
                    detailContainer={getDetailContainer()}
                />
            }
            receptionDxGrid={<ReceptionDxGrid14852 userId={props.userId}/>}
            receptionForm={<ReceptionForm14852/>}
            receptionFormDialog={
                <ReceptionFormDialog14852
                    form={<ReceptionForm14852/>}
                    detailContainer={getDetailContainer()}
                />
            }
            adminSkudDxGrid={<AdminSkudDxGrid14852/>}
            adminSkudForm={<AdminSkudForm14852/>}
            {...props}
        />
    );
}

export default RequestsPage14852;
